import React from 'react';
import { DefaultFilterType } from '../constants';
import { FilterCheckbox } from './filter-checkbox';
import { FilterFlatList, FilterHierarchy, FilterLocation, FilterPerson, FilterUnit } from './filter-code';
import { FilterCommonProps } from './filter-common';
import { FilterDate } from './filter-date';
import { FilterDefaultValue } from './filter-default-value';

import styles from './filter-factory.scss';

const filterMapping = {
  [DefaultFilterType.FlatList]: FilterFlatList,
  [DefaultFilterType.Hierarchy]: FilterHierarchy,
  [DefaultFilterType.Date]: FilterDate,
  [DefaultFilterType.Checkbox]: FilterCheckbox,
  [DefaultFilterType.Unit]: FilterUnit,
  [DefaultFilterType.Location]: FilterLocation,
  [DefaultFilterType.Person]: FilterPerson,
  [DefaultFilterType.FlatListSequential]: FilterFlatList,
  [DefaultFilterType.FlatListWithCategories]: FilterFlatList,
  [DefaultFilterType.HierarchyWithCategories]: FilterHierarchy,
  [DefaultFilterType.FlatListSequentialWithCategories]: FilterFlatList,
  [DefaultFilterType.HierarchySequentialWithCategories]: FilterHierarchy
};

export const renderDefaultValue = (type: DefaultFilterType) => type !== DefaultFilterType.Date;

export const FilterFactory: React.FC<FilterCommonProps> = (props) => {
  const Component = filterMapping[props.metadata?.advancedSearchType];

  return <div className={styles.defaultValue}>
    {Component
      ? (renderDefaultValue(props.metadata?.advancedSearchType)
        ? <FilterDefaultValue
          filter={props.filter}
          updateFilter={props.updateFilter}
          translation={props.translation}>
          <Component {...props} />
        </FilterDefaultValue>
        : <Component {...props} />)
      : <div className={styles.notSupported}>{props.translation?.filters_not_supported}</div>}
  </div>;
};
